import { Typography, Box, Stack } from "@mui/material";

export default function RegistrationRewardsSettings({ rawData }) {
  if (!rawData) {
    return (
      <Typography color="error" variant="body2">
        Invalid or empty JSON data
      </Typography>
    );
  }

  return (
    <Stack spacing={1} sx={{ p: 2, pt: 1, flex: 1, justifyContent: 'center' }}>
      <Box sx={{
        p: 1.5,
        textAlign: 'center',
      }}>
        <Typography variant="body2" sx={{
          color: 'text.secondary',
          fontSize: '0.7rem',
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: 0.5,
          mb: 0.5,
        }}>
          Coins Reward
        </Typography>
        <Typography variant="h6" sx={{
          fontWeight: 700,
          color: 'text.primary',
          fontSize: '0.8rem',
        }}>
          {rawData ? `${String(rawData.coinsReward)} coins` : "No data"}
        </Typography>
      </Box>
    </Stack>
  )
}
